import { styled } from '@innowise-group/mui-kit';
import { Icon as BaseIcon } from '@innowise-group/mui-kit';

export const Icon = styled(BaseIcon)`
  svg,
  svg:hover {
    fill: ${({ theme }) => theme.palette.general.smart};
  }
`;
